import React, { FC, ReactElement, ReactNode } from 'react';
import { ConfigYamlMembers, Maybe } from '../../gatsby-types';
import { ImageAtom } from './ImageAtom';
import { MaterialIcon } from './MaterialIcon';

type Props = Readonly<{
  members: ReadonlyArray<ConfigYamlMembers>;
}>;

export const MembersContainer: FC<Props> = ({ members }): ReactElement => {
  return (
    <div className='container grid sm:grid-cols-none md:grid-cols-3 gap-1 max-w-full mx-auto p-2 flex flex-wrap'>
      {members.map((member: ConfigYamlMembers, i: number) => (
        <div key={i} className='rounded overflow-hidden shadow-lg'>
          {iconImage(member.icon)}
          <div className='px-6 py-4'>
            <p className='underline font-serif'>{member.headline}</p>
            <p className='font-bold text-red-600 text-xl pb-4'>{member.nickname} </p>
            {renderComment(member.comment)}
            {renderFavourite(member.favourite)}
            <br/>
            {externalPage(member.link)}
          </div>
        </div>
      ))}
    </div>
  );
};

const iconImage = (icon: Maybe<string>): ReactNode => {
  const className = 'rounded-full m-auto border-green h-64 w-64 border-green-500 border-4';

  if (icon === null) {
    return <ImageAtom filename='default.png' className={className}/>;
  }
  if (icon.startsWith('http')) {
    return <img src={icon} className={className}/>;
  }

  return <ImageAtom filename={icon} className={className}/>;
};

const externalPage = (link: Maybe<string>): ReactNode => {
  if (link === null) {
    return null;
  }

  return (
    <div className='text-right'>
      <a href={link} target='_blank' rel='noreferrer'>
        <MaterialIcon name='public' text='Profile Page' className='italic text-blue-400 hover:bg-blue-100'/>
      </a>
    </div>
  );
};

const renderComment = (comment: Maybe<string>): ReactNode => {
  if (comment === null) {
    return null;
  }

  return <pre className='text-sm whitespace-pre-wrap font-sans'>{comment}</pre>;
};

const renderFavourite = (favourites: Maybe<ReadonlyArray<Maybe<string>>>): ReactNode => {
  if (favourites === null) {
    return null;
  }

  return favourites.filter((f: Maybe<string>): f is string =>
    f !== null
  ).map((f: string, i: number) =>
    <MaterialIcon key={i} name='casino' text={f} className='bg-gray-200'/>
  );
};
